import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import Premium from 'shared/ui/icons/Premium';
import Dollar from 'shared/ui/icons/Dollar';

import { isTranslate } from 'shared/lib/lang';

import Hint from 'shared/ui/Hint/Hint';

import styles from 'shared/ui/Hint/Hint.module.scss';

import useCheapestTariffWithBooleanLimit, {TariffCondition} from '../../model/useCheapestTariffWithBooleanLimit';

interface IHintPremiumProps {
    condition: TariffCondition,
}

const HintPremium: React.FC<IHintPremiumProps> = ({condition}) => {

    const tariff = useCheapestTariffWithBooleanLimit(condition);
    if (null === tariff) {
        return <></>;
    }

    return <Hint trigger={
        <span className={styles.question}>
            { isTranslate() ? <Dollar /> : <Premium /> }
        </span>}
    >
        <>
            {t`Доступно на тарифах от 100 рублей в месяц.`}
            {
                !isTranslate() &&
                <a
                    href={AppUrls.TARIFFS}
                    target="_blank"
                    rel="noreferrer"
                >
                    {} {t`Подключить`}
                </a>
            }
        </>
    </Hint>;
};

export default HintPremium;